import { useCallback } from "react";

import { STATUS_COLOR } from "@hl/base-components/lib/theme/colors";
import { Box, Button, Center, Loader, Text } from "@mantine/core";

import { _CollectionType } from "../../../../../apollo/graphql.generated";
import { useGetRankedAuctionEarningsQuery } from "../queries.graphql.generated";

import { useClaimRankedAuctionEarnings } from "./ranked-auction-tx";

type ClaimProps = {
  mintVectorId: string;
  collection: {
    id: string;
    collectionType: _CollectionType;
  };
};
export const ClaimRankedAuctionEarnings = ({
  mintVectorId,
  collection,
}: ClaimProps) => {
  const { data, loading, refetch } = useGetRankedAuctionEarningsQuery({
    variables: {
      mintVectorId,
    },
  });

  const handleFinish = useCallback(() => {
    const timeout = setTimeout(refetch, 1000);
    return () => clearTimeout(timeout);
  }, [refetch]);

  const { start, buttonLabel, buttonLoading, buttonDisabled, error } =
    useClaimRankedAuctionEarnings({
      mintVectorId,
      collectionId: collection.id!,
      collectionType: collection.collectionType,
      onFinish: handleFinish,
    });

  if (loading) {
    return (
      <Center p="md">
        <Loader />
      </Center>
    );
  }
  const alreadyClaimed = data?.rankedAuction?.auctionEarningsClaimed;
  if (alreadyClaimed) {
    return null;
  }

  return (
    <Box p="md">
      <Button
        size="lg"
        fullWidth
        loading={buttonLoading}
        disabled={buttonDisabled}
        onClick={start}
      >
        {buttonLabel || "Claim earnings"}
      </Button>
      {error && (
        <Text align="center" mt={8} size="xs" color={STATUS_COLOR.ERROR}>
          {error}
        </Text>
      )}
    </Box>
  );
};
